import { render } from "./OwnProfileCard.vue?vue&type=template&id=b6ade9f6&scoped=true&ts=true"
import script from "./OwnProfileCard.vue?vue&type=script&lang=ts"
export * from "./OwnProfileCard.vue?vue&type=script&lang=ts"

import "./OwnProfileCard.vue?vue&type=style&index=0&id=b6ade9f6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ade9f6"]])

export default __exports__